import { Component } from '@angular/core';
import { Toast } from 'ngx-toastr';
import { NgClass } from '@angular/common';

@Component({
  standalone: true,
    selector: 'app-notifications',
    templateUrl: './notifications.component.html',
    styleUrls: ['./notifications.component.scss'],
    imports: [NgClass]
})
export class NotificationsComponent extends Toast {

  constructor() {
    super();
  }

}
